<template>
  <div class="app-container member-list">
    <basic-container class = "member-list-container">
      <el-row>
        <el-col :span="18">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="选择人员" name="1">
              <el-row>
                <el-col :span="12">
                  <el-input class="member-list-filter-value" v-model.trim="nickname" 
                          @keyup.enter.native="searchChange" placeholder="昵称，至少输入两个字符" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </el-col>
                <el-col :span="12">
                  <div>
                    <el-button type="primary" icon="el-icon-search" circle size="small" @click="searchChange"></el-button>
                  </div>
                </el-col>
              </el-row>
              <el-table
                ref="multipleTable"
                border
                :table-loading="tableLoading"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="nickname" label="姓名"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="选择标签" name="2">标签</el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="6">
          <div class="select">
            <div class="select-content">
              <h2>已选择</h2> 
              <div>已选择 {{selectMember.length}} 人 &nbsp;&nbsp; {{ selectTag.length}} 个标签</div>
              <div class="select-list">
                <div v-for="(item, index) in selectMember" :key="index">
                  <el-tag class="select-list-item" type="info" closable @close="handleDel(item)"> {{item.nickname}} </el-tag>
                </div>
                <div v-for="(item, index) in selectTag" :key="index">
                  <el-tag class="select-list-item" type="info" closable @close="handleDel(item)"> {{item.nickname}} </el-tag>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </basic-container>
  </div>
</template>

<script>
import { getMemberList } from '@/api/app/exam'
import { mapGetters } from 'vuex'

export default {
  name: 'memberDialog',
  props: {
    selectList: {
      type: Array,
    }
  },
  data() {
    return {
      selectRow: '',
      // 列表页面
      tableData:[],
      nickname: '',
      tableLoading: false,
      activeName: '1',
      selectMember: [],
      selectTag: [],
    }
  },
  created() {
    this.selectMember = this.selectList.members
    this.selectTag = this.selectList.tags
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  activated() {
  },
  methods: {
    getList() {
      if (this.nickname === '' || this.nickname.length < 2) {
        this.$message({
          message: '搜索用户不能为空，且要大于两个字符',
          type: 'error'
        })
      } else {
        this.tableLoading = true
        getMemberList({nickname: this.nickname}).then(res => {
          this.tableData = res.data.data
          this.tableLoading = false
        }).catch(error => {
          this.$message({
            message: '搜索用户失败',
            type: 'error'
          })
          this.tableLoading = false;
        })
      }
    },
    searchChange() {
      this.getList()
    },
    handleSelectionChange(val) {
      if (val) {
        val.forEach(item => {
          if (!this.selectMember.some(val => val.memberId === item.memberId)) {
              this.selectMember.push(item)
          }
        })
      }
    },
    handleDel(member) {
      this.selectMember = this.selectMember.filter(item => { return item.memberId != member.memberId });
    },
    rowClick (row) {
      this.selectRow = row.$index
      this.selectmember = row
    },
    handleView(row, index) {
      this.$router.push({
        path: `/app/exam/member/show/${row.id}`,
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.member-list {
  &-filter {
    &-value {
      width: 96%!important;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }

  .select {
    min-height: 300px;
    background-color: #fafafa;
    &-content{
      margin: 10px;
    }
    &-choise {
      margin-top: 5px;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      color: #999;
      padding: 0 10px;
    }
    &-list {
      margin: 10px;
      &-item {
        margin-bottom: 10px;
        font-size: 16px;
      }
    }
  }
}
</style>
